<template>
  <div class="review p_t">
    <TopHead title="经典回顾"></TopHead>

    <van-pull-refresh v-model="loading" @refresh="onRefresh">
      <van-list
        :immediate-check="false"
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div class="list_out">
          <div class="items" v-for="(item,index) in list">
            <div class="p_r d_f ali_c j_c">
              <div v-if="!item.showVideo" @click="item.showVideo = true">
                <img :src="item.coverUrl" alt="" class="bg p_a">
                <img src="../assets/img/review_play.png" alt="" class="play p_r">
              </div>
              <video v-else :src="item.videoUrl" controls></video>
            </div>
            <div class="text">{{item.videoName}}</div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
  export default {
    name: "Review",
    data() {
      return {
        refreshing:false,
        loading:true,
        finished:false,
        list:[],
        params:{
          pageIndex:1,
          pageSize:10,
        },
      }
    },
    created(){
      this.listVideo();
    },
    methods: {
      listVideo(){
        this.loading = true;
        this.$api.listVideo(this.params).then(res => {

          this.loading = false;
          if (this.refreshing) {
            this.refreshing = false;
          }
          if(res.data.recordCount){
            this.list = this.list.concat(JSON.parse(JSON.stringify(res.data.rows)));
          }
          this.list.map(item => {
            if(item.showVideo == undefined || item.showVideo == null) item.showVideo = false;
          });
          let list = res.data.rows;
          if (!list || list.length < this.params.pageSize) {
            this.finished = true;
          }
        })
      },
      onRefresh(){
        this.list = [];
        this.finished = false;
        this.params.pageIndex = 1;
        this.listVideo();
      },
      onLoad(){
        let me = this;
        if(me.loading) return
        let page = me.params.pageIndex;
        page = page ? page + 1 : 1;
        this.params.pageIndex = page;
        this.listVideo();
      },
    }
  }
</script>

<style scoped lang="scss">
  .items{
    video{
      width: 100%;
      height: 100%;
      background-color: black;
    }
    .text{
      font-size: 14px;
      font-weight: bold;
      color: #333333;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .d_f{
      .play{
        width: 39px;
        height: 39px;
      }
      .bg{
        filter: blur(4px);
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
      }
      margin-bottom: 10px;
      height: 243px;
      overflow: hidden;
      border-radius: 4px 4px 0 0;
    }
    padding: 19px 38px 15px;
    border-bottom: 4px solid #EBEBEB;
  }

</style>
